export function accordionScript() {
    document.addEventListener('DOMContentLoaded', function () {
        var headers = document.querySelectorAll('.accordion-item');
        headers.forEach(function (header) {
            header.addEventListener('click', function () {
              //  var content = header.querySelector('.accord-content');

                if (header.classList.contains('active')) {
                    //content.classList.remove('active');
                    header.classList.remove('active');
                    header.querySelector('img').attributes.src.value = header.querySelector('img').getAttribute('data-plus');
                } else {
                    // headers.forEach(function (otherHeader) {
                    //     otherHeader.nextElementSibling.classList.remove('active');
                    //     otherHeader.classList.remove('active');
                    //     otherHeader.querySelector('img').attributes.src.value = header.querySelector('img').getAttribute('data-plus');
                    // });
                  //  content.classList.add('active');
                    header.classList.add('active');
                    header.querySelector('img').attributes.src.value = header.querySelector('img').getAttribute('data-minus');

                    // Przewijanie do otwartego akordeonu
                    // var headerOffset = header.getBoundingClientRect().top + window.scrollY - 90;
                    // window.scrollTo({top: headerOffset, behavior: 'smooth'});

                }
            });
        });

    })
}